module.exports = {
  "chat.end":"Mulai ulang percakapan obrolan Anda",
  "chat.endall":"Akhiri Obrolan",
  "chat.cancel":"Membatalkan",
  "chat.cookie":"Asisten digital ini menggunakan cookie untuk memastikan Anda mendapatkan pengalaman terbaik",
  "chat.learn":"Belajarlah lagi",
  "chat.minimize":"Memperkecil",
  "chat.hide":"Menutup",
  "chat.hidebot.text":"Tutup akan membuat avatar menghilang selama 15 menit",
  "chat.hidebot":"Tutup Bot",
  "chat.restart":"Mengulang kembali",
  "switch.language":"Ganti Bahasa",
  "switch.property":"Beralih Properti",
  "restart.converstation":"Mulai ulang Percakapan",
  "chat.endtext":"Apakah Anda yakin ingin mengakhiri obrolan saat ini?",
  "check.availabity":"Cek ketersediaan",
  "check.availabity.submit":"Kirim",
  "check.availabity.cancel":"Membatalkan",
  "check.availabity.adults":"Dewasa ",
  "check.availabity.children":"Anak-anak",
  "check.availabity.child.age":"Usia - Anak",
  "feedback.leave":"Tinggalkan umpan balik",
  "feedback.leave.message":"Tinggalkan pesan",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
